import AddPostPage from "./AddPostPage";

export const AddPostPageConfig = {
  routes: [
    {
      path: "/pages/posts/add-post",
      exact: true,
      component: AddPostPage
    }
  ]
};
